export const isExactIdMatch = (id: string, priorityFieldId: string) => id === priorityFieldId;
